module.exports = __webpack_public_path__ + "img/20191209165054360截图20191209164147323.b4aac8d5.jpg";